import React,{Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {logout} from '../../actions/authActions';
import {showMessage,showError,setInboxCount,setDatesCount} from '../../actions/uiActions';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ExitToApp from '@mui/icons-material/ExitToApp';
import Dashboard from '@mui/icons-material/Dashboard';
import Domain from '@mui/icons-material/Domain';
import Group from '@mui/icons-material/Group';
import CalendarToday from '@mui/icons-material/CalendarToday';
import MailIcon from '@mui/icons-material/Mail';
import AssignmentInd from '@mui/icons-material/AssignmentInd';
import PrintIcon from '@mui/icons-material/Print';
import Send from '@mui/icons-material/Send';
import ProfilePictureComponent from '../../components/ProfilePicture';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Drawer from '@mui/material/Drawer';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { Link } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip/Tooltip';
import Badge from '@mui/material/Badge';
import FormatAlignJustify from '@mui/icons-material/FormatAlignJustify';
import { withRouter } from '../../utils/withRouter';
import { Analytics, Archive, GroupAdd } from '@mui/icons-material';
class DashboardComponent extends Component
{
    state=
    {
        anchorEl: null,
        drawer:false
    }
    
    toggleDrawer = (open) => {
      if(this.state.drawer!=open)
        this.setState({
          drawer: open,
        });
      };
    handleMenu = event => {
        this.setState({ anchorEl: event.currentTarget });
      };
    
      handleClose = () => {
        this.setState({ anchorEl: null });
      };
    roleText=(role)=>{
      switch(role)
      {
          case "coach":
              return "Student Loan Coach";
          case "sales":
              return "Sales Representative";
          default:
              return "System Administrator";
      }
  }
    render()
    {
        const open = Boolean(this.state.anchorEl);
        return <div>
            <Drawer open={this.state.drawer} onClose={()=>this.toggleDrawer(false)}>
          <div
            tabIndex={0}
            role="button"
            onClick={()=>this.toggleDrawer(false)}
            onKeyDown={()=>this.toggleDrawer(false)}
          >
            <div className="sidebar">
            <header>
                
                    <IconButton color="inherit" className="menu-button" aria-label="Menu" onClick={()=>this.toggleDrawer(false)}>
                    <ChevronLeftIcon />
                        </IconButton>
              <div className="row">
                <div className="col-3 text-center">
                    <ProfilePictureComponent className="avatar" />
                </div>
                <div className="col-9 text-left">
                <h1>{this.props.account.name}</h1>
                <h2>{this.roleText(this.props.account.role)}</h2>
                </div>
              </div>
            </header>
            <List>
            <ListItem button key="dashboard">
            <Link to="/">
              <ListItemIcon className="icon"><Dashboard /></ListItemIcon>
              <ListItemText className="light-text" primary="Dashboard" />
            </Link>
            </ListItem>
            <ListItem button key="dashboard">
            <Link to="/users">
              <ListItemIcon className="icon"><Group /></ListItemIcon>
              <ListItemText className="light-text" primary="Users" />
            </Link>
            </ListItem>
            {this.props.account.role!='sales'&&<ListItem button key="calendar">
            <Link to="/calendar">
              <ListItemIcon className="icon">
              {this.props.calendar>0&&<Badge badgeContent={this.props.calendar} color="secondary"><CalendarToday /></Badge>}
    {this.props.calendar===0&&<CalendarToday />}
              </ListItemIcon>
              <ListItemText className="light-text" primary="Calendar" />
            </Link>
            </ListItem>}
            {this.props.account.super&&<ListItem button key="domains">
            <Link to="/domains">
              <ListItemIcon className="icon"><Domain /></ListItemIcon>
              <ListItemText className="light-text" primary="Domains" />
            </Link>
            </ListItem>}
            <ListItem button key="forms">
              <Link to="/forms">
                <ListItemIcon className="icon"><FormatAlignJustify /></ListItemIcon>
                <ListItemText className="light-text" primary="Forms" />
              </Link>
            </ListItem>
            {this.props.account.super&&<ListItem button key="accounts">
            <Link to="/accounts">
              <ListItemIcon className="icon">
              <AssignmentInd />
              </ListItemIcon>
              <ListItemText className="light-text" primary="Administrators" />
            </Link>
            </ListItem>}
            <ListItem button key="bulk-actions">
              <Link to="/bulk-actions">
                <ListItemIcon className="icon">
                  <GroupAdd />
                </ListItemIcon>
                <ListItemText className="light-text" primary="Bulk Actions" />
              </Link>
            </ListItem>
            <ListItem button key="analytics">
              <Link to="/analytics">
                <ListItemIcon className="icon">
                  <Analytics />
                </ListItemIcon>
                <ListItemText className="light-text" primary="Analytics" />
              </Link>
            </ListItem>
            <ListItem button key="fax">
              <Link to="/fax">
                <ListItemIcon className="icon">
                  <Send />
                </ListItemIcon>
                <ListItemText className="light-text" primary="Fax" />
              </Link>
            </ListItem>
            <ListItem button key="send fax">
              <Link to="/send/fax">
                <ListItemIcon className="icon">
                  <PrintIcon />
                </ListItemIcon>
                <ListItemText className="light-text" primary="Send Fax" />
              </Link>
            </ListItem>
            <ListItem button key="logout">
              <Link onClick={this.props.logout} to="/">
                <ListItemIcon className="icon"><ExitToApp /></ListItemIcon>
                <ListItemText className="light-text" primary="Log Out" />
              </Link>
            </ListItem>
            </List>
            </div>
          </div>
        </Drawer>
          <AppBar position="static">
              <Toolbar className="main-toolbar">
              <IconButton color="inherit" className="menu-button" aria-label="Menu" onClick={()=>this.toggleDrawer(true)}>
                  <MenuIcon />
              </IconButton>
              <div className="space-filler"></div>
              <Tooltip title="Dashboard" className="mobile-hidden">
                <IconButton onClick={()=>this.props.history.push("/")}>
                  <Dashboard />
                </IconButton>
              </Tooltip>
              <Tooltip title="Users" className="mobile-hidden">
                <IconButton onClick={()=>this.props.history.push("/")}>
                  <Group />
                </IconButton>
              </Tooltip>
              {this.props.account.super&&<Tooltip title="Domains" className="mobile-hidden">
                <IconButton onClick={()=>this.props.history.push("/domains")}>
                  <Domain />
                </IconButton>
              </Tooltip>}
              <Tooltip title="Forms" className="mobile-hidden">
                <IconButton onClick={()=>this.props.history.push("/forms")}>
                <FormatAlignJustify />
                </IconButton>
              </Tooltip>
              {this.props.account.super&&<Tooltip title="Administrators Management" className="mobile-hidden">
                <IconButton onClick={()=>this.props.history.push("/accounts")}>
                  <AssignmentInd />
                </IconButton>
              </Tooltip>}
              <Tooltip title="Bulk Actions" className="mobile-hidden">
                <IconButton onClick={()=>this.props.history.push("/bulk-actions")}>
                  <GroupAdd />
                </IconButton>
              </Tooltip>
              <Tooltip title="Analytics" className="mobile-hidden">
                <IconButton onClick={()=>this.props.history.push("/analytics")}>
                  <Analytics />
                </IconButton>
              </Tooltip>
              <Tooltip title="Get Fax" className="mobile-hidden">
                <IconButton onClick={()=>this.props.history.push("/fax")}>
                  <Send />
                </IconButton>
              </Tooltip>
              <Tooltip title="Send Fax" className="mobile-hidden">
                <IconButton onClick={()=>this.props.history.push("/send/fax")}>
                  <PrintIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Log Out" className="mobile-hidden">
                <IconButton onClick={this.props.logout}>
                <ExitToApp />
                </IconButton>
              </Tooltip>
              </Toolbar>
          </AppBar>
        </div>
    }
}
const mapStateToProps= state =>{
    return {
        account:state.auth.account,
        logout:logout,
        inbox:state.ui.inbox,
        calendar:state.ui.calendar
    }};
    DashboardComponent.propTypes=
    {
        account:PropTypes.object.isRequired,
        logout:PropTypes.func,
        showError:PropTypes.func.isRequired,
        showMessage:PropTypes.func.isRequired
    };
export default withRouter(connect(mapStateToProps, { logout, showError, showMessage, setInboxCount, setDatesCount })(DashboardComponent));